var _path, _rect, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDnaEngage = function SvgDnaEngage(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 0h35v35H0z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#FACF1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 10.5H12v14l1.5-1.5 2.5 1.5 2-1.5 2 1.5 2-1.5 2 1.5v-14Zm0 0c-.837 0-2.5 0 0 0Z",
    stroke: "#1D1737",
    strokeWidth: 1.3,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m15 16 2.5 2 3.5-3.5",
    stroke: "#1D1737",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgDnaEngage;